import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@resurs/midas-react'
import { getText } from '../../../../../internal/TextLabels'
import { EmailOrPhoneLink } from './EmailOrPhoneLink'
import { CustomerHelper } from '../../../../../util/customerHelper'

const initCoCustomer = ({ coCustomer }) => {
  if (!coCustomer) {
    return { valid: true }
  }
  const helper = new CustomerHelper(coCustomer)
  return {
    email: helper.email,
    phoneNumber: helper.aPhoneNumber || coCustomer.aphoneNumber,
  }
}

export const SignDigitalAgreement = props => {
  const [customer, setCustomer] = useState({
    email: props.customer.email,
    phoneNumber: props.customer.aPhoneNumber || props.customer.aphoneNumber,
  })
  const [coCustomer, setCoCustomer] = useState(initCoCustomer(props))

  const [buttonEnabled, setButtonEnabled] = useState(false)
  useEffect(() => {
    if (customer.valid && coCustomer.valid) {
      setButtonEnabled(true)
    } else {
      setButtonEnabled(false)
    }
  }, [customer, coCustomer])

  return (
    <>
      <h5>{getText('payApply.sign.digitalAgreement.title')}</h5>
      <p>{getText('payApply.sign.digitalAgreement.description')}</p>
      <EmailOrPhoneLink
        {...props}
        phoneNumber={customer.phoneNumber}
        email={customer.email}
        onChange={setCustomer}
      />
      {props.coCustomer && (
        <>
          <h5>{getText('payApply.sign.digitalAgreement.coApplicantTitle')}</h5>
          <EmailOrPhoneLink
            {...props}
            email={coCustomer.email}
            phoneNumber={coCustomer.phoneNumber}
            onChange={setCoCustomer}
          />
        </>
      )}
      <div style={{ textAlign: 'right', marginTop: 25 }}>
        <Button
          id="digital-agreement-sign-btn"
          type="primary"
          loading={props.isNewPageLoading}
          disabled={!buttonEnabled}
          autoFocus
          onClick={() =>
            props.onNext({
              customer,
              coCustomer: props.coCustomer ? coCustomer : null,
            })
          }
        >
          {getText('payApply.sign.digitalAgreement.sendLink')}
        </Button>
      </div>
    </>
  )
}

SignDigitalAgreement.propTypes = {
  customer: PropTypes.shape({
    aPhoneNumber: PropTypes.string,
    aphoneNumber: PropTypes.string,
    email: PropTypes.string,
  }),
  coCustomer: PropTypes.shape({
    aPhoneNumber: PropTypes.string,
    aphoneNumber: PropTypes.string,
    email: PropTypes.string,
  }),
}

SignDigitalAgreement.defaultProps = {
  customer: new CustomerHelper(),
  coCustomer: undefined,
}
